import { useMemo } from 'react';
import { Label } from '@britishcouncil/react-admin';
import { SemanticCOLORS } from 'semantic-ui-react';
import { SpeakingSlotType } from 'api/planning';

type Props = {
  speakingSlotType: SpeakingSlotType;
};

export const SpeakingTypeBadge = ({ speakingSlotType }: Props) => {
  const color: SemanticCOLORS = useMemo(() => {
    switch (speakingSlotType) {
      case SpeakingSlotType.IPC:
        return 'grey';
      case SpeakingSlotType.IPA:
        return 'teal';
      case SpeakingSlotType.RSS:
        return 'pink';
      case SpeakingSlotType.SWA:
        return 'violet';
      default:
        return 'grey';
    }
  }, [speakingSlotType]);

  return <Label color={color}>{SpeakingSlotType[speakingSlotType]}</Label>;
};
